import React from 'react';
import PatientQueue from './PatientQueue';
import { RPM_ALERT_QUEUE_ROUTE } from '../../constants/other';

const RpmThresholdAlertQueue = () =>
    <PatientQueue
        showQueueCount
        rpmThresholdAlertColumns
        chartColumn
        showFilters
        showRpmDeviceFilter
        showRpmAlertSeverityFilter
        page
        rowHeight={200}
        queue={RPM_ALERT_QUEUE_ROUTE}
        endpoint="Urgent?typesToInclude=27,28,29"
        label="RPM Threshold Alerts"
    />;

export default RpmThresholdAlertQueue;
